<template>
  <div class="row no-gutters body">
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
    </div>
    <div class="col-12 pb-5 main-card" v-if="!pageloader">
        <div class="row no-gutters">
            <div class="col-lg-3 middle-background">
                <div class="row no-gutters mb-2">
                    <br />
                </div>
                <div class="pt-lg-3">
                    <div class="d-flex ml-3 ml-lg-5 mt-5 p-lg-2 pt-4 pointer" @click="NavToJobsPage">
                        <img src="../assets/Back.svg" class="backbtn" alt="backbtn"/>
                        <p class="fontsize20 proximanova-semibold black my-auto ml-3 mt-2">Screening Questions</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 mt-3 d-lg-flex no-gutters pb-5">
                <div class="col-lg-6 no-gutters">
                    <span class="fontsize16 proximanova-semibold black ml-3 ml-lg-5 pl-lg-4 mr-3">Video Recording</span>
                    <div class="ml-3  ml-lg-5 pl-lg-2 mr-3 mt-lg-3">
                        <div class="card">
                            <video autoplay src="" nocontrols class="vidheight" preload="metadata" controlsList="nodownload" @ended="endPlayingVideo"  id="videscreeningqsns" >
                                <source id="sourcepost" type="video/mp4">
                                <source id="sourcepost" type="video/quicktime">
                                <source id="sourcepost" type="video/webm">
                            </video>
                            <div class="card-img-overlay ">
                                <div id="bottom">
                                <div class="black_overlay2">
                                    <div class="pb-3 d-flex justify-content-between p-3 ">
                                        <div>
                                        <div class="d-flex button-create backgroundcolorblack pointer p-1 pl-2 pr-2 mouseoverbtn2 borderradius20 white" v-if="doneAnswerbtnClicked || startedsmAnswering" @click="previewPlay">
                                            <img src="../assets/record_white_play.svg" v-if="!previewPlaying" width="28px" height="28px" class="my-auto" alt="preview">
                                            <img src="../assets/record_white_pause.svg" v-else width="28px" height="28px" class="my-auto" alt="preview">
                                            <span class="proximanova my-auto ml-1 pointer" v-if="!previewPlaying">Preview</span>
                                            <span class="proximanova my-auto ml-1 pointer" v-else>Pause</span>
                                        </div>
                                        </div>
                                        <span class="white text-right proximanova pointer" @click="muteUnmuteVideo" v-if="isVideoMuted">
                                            <img src="../assets/videovolume.svg" class="volumebtn" width="28px" height="28px" alt="volume">
                                        </span>
                                        <span class="white text-right proximanova pointer" @click="muteUnmuteVideo" v-if="!isVideoMuted">
                                            <img src="../assets/videomute.svg" class="volumebtn" width="28px" height="28px" alt="mute">
                                        </span>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 no-gutters" v-if="beforeStartAnswering">
                    <div class="ml-3 mr-3 ml-lg-5">
                        <span class="fontsize16 proximanova-semibold black">Note</span>
                        <div class="mt-3"></div>
                        <div class="d-flex flex column mt-md-2 mt-1" v-for="(instruction , index) in instructions" :key="index">
                            <div class="d-felx">
                                <img src="../assets/screeningInstructions.svg" alt="instructions">
                                <span class="fontsize12 proximanova black mt-1 ml-2">{{instruction}}</span>
                            </div>
                        </div>
                        <span class="btn button-create backgroundcolorblack mouseoverbtn2 borderradius20 white mt-4 ansrbtn" id="search" @click="startAnsweringQuestions">
                            <span class="bold16px_white proximanova">Start Answering</span>
                        </span>
                    </div>
                </div>
                <div class="col-lg-6 no-gutters my-auto" v-if="!beforeStartAnswering">
                    <div class="ml-3 mr-3 ml-lg-5 mr-lg-5 d-flex flex-column" v-if="!questionsEnded">
                        <span class="fontsize16 proximanova-semibold black">Questionnaire</span>
                        <div class="mt-3"></div>
                        <div class="d-flex flex-column">
                            <div class="col-12 pl-0 pr-0 d-flex flex-column">
                                <span class="fontsize24 proximanova black">{{selectedQsnIndex}}/{{screeningQuestions.length}} Question</span>
                                <span class="fontsize16 proximanova black mt-3">Time Limit for each Question 1 minute</span>
                                <span class="fontsize16 proximanova black60 mt-1">After 1munite your question will be auto submited if you are not able to answer in time.</span>
                            </div>
                            <div class="borderbottom1 mt-2 mt-lg-3 mb-lg-3 mb-2 d-none d-lg-block"></div>
                            <div class="col-4 mt-3 mb-3 text-center d-none d-lg-block">
                                <span class="black mb-2 text-left proximanova-bold fontsize14 d-none d-lg-block">Time is running out</span>
                                <!-- <span class="black proximanova-semibold fontsize16 d-none d-lg-block" v-if="totalSeconds === 60 "> <span class="countdownstyles"> 1</span> : <span class="countdownstyles">00</span></span>
                                <span class="black proximanova-semibold fontsize16 d-none d-lg-block" v-else><span class="countdownstyles"> 00</span> : <span class="countdownstyles">{{totalSeconds}}</span></span> -->
                                <div class="d-flex">
                                    <div class="countdownstyles d-flex flex-column" :class="{'backgroundcolorgreen':(totalSeconds <= 59 && totalSeconds > 40), 'backgroundcolororange':(totalSeconds <= 40 && totalSeconds > 20), 'backgroundcolorred':(totalSeconds <= 20)}">
                                        <span v-if="totalSeconds === 60">01</span><span v-else>00</span><span class="fontsize8 text-uppercase white mt-1">Minutes</span>
                                    </div> 
                                    <div class="fontsize20 black bold my-auto ml-2 mr-2">:</div> 
                                    <div class="countdownstyles d-flex flex-column" :class="{'backgroundcolorgreen':(totalSeconds <= 59 && totalSeconds > 40), 'backgroundcolororange':(totalSeconds <= 40 && totalSeconds > 20), 'backgroundcolorred':(totalSeconds <= 20)}">
                                        <span v-if="totalSeconds === 60">00</span><span v-else>{{totalSeconds}}</span><span class="fontsize8 text-uppercase white mt-1">Seconds</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="borderbottom1 mt-2 mt-lg-3 mb-lg-3 mb-2"></div>
                        <span class="fontsize32 proximanova-semibold black mr-lg-4">{{selectedQsn}}</span>
                        <div class="borderbottom1 mt-2 mt-lg-3 mb-lg-3 mb-2"></div>
                        <div class="d-flex d-none d-lg-block">
                            <div class="d-flex">
                                <span class="btn button-create backgroundcolorblack mouseoverbtn2 borderradius20 white mt-4 ansrbtn d-none d-lg-block" v-if="!startedAnswering" @click="startAnsweringAQuestion">
                                    <span class="bold16px_white proximanova">Start Recording</span>
                                </span>
                                <span class="btn button-create backgroundcolorblack mouseoverbtn2 borderradius20 white mt-4 ansrbtn d-none d-lg-block" v-if="startedAnswering && !doneAnswerbtnClicked" @click="doneAnsweringAQuestion">
                                    <span class="bold16px_white proximanova">Done Recording</span>
                                </span>
                                <span class="btn button-create backgroundcolorblack mouseoverbtn2 borderradius20 white mt-4 ansrbtn d-none d-lg-block" :disabled="doneAnswerbtnClicked" v-if="doneAnswerbtnClicked && !submitButtonClicked" @click="AddIntoFinalList">
                                    <span class="bold16px_white proximanova">Next</span>
                                </span>
                                <span class="d-none d-lg-block mt-2">
                                    <img src="../assets/uploadvideo.svg" width="30px" class="img-fluid ml-5 mt-4 " alt="uploading" v-if="submitButtonClicked">
                                </span>
                            </div>
                        </div>
                        <div>
                            <span v-if="videoUploadingErrorMessage" class="light-red proximanova fontsize14">{{videoUploadingErrorMessage}}</span>
                        </div>
                        <div class="d-flex d-block d-lg-none">
                            <span class="btn button-create backgroundcolorblack borderradius20 white mt-4 ansrbtn d-block d-lg-none" v-if="!startedsmAnswering" @click="startsmAnsweringAQuestion">
                                <span class="bold16px_white proximanova">Start Recording</span>
                                <input
                                    type="file"
                                    class="form-control-file"
                                    id="screeningVideoRecord"  multiple  accept="video/*" capture @change="onScreeningVideoSelected"
                                    @click="startsmAnsweringAQuestion()"
                                    hidden
                                />
                            </span>
                            <span class="btn button-create backgroundcolorblack borderradius20 white mt-4 ansrbtn d-block d-lg-none" v-if="startedsmAnswering" @click="startsmAnsweringAQuestion">
                                <span class="bold16px_white proximanova">Re-record</span>
                                <input
                                    type="file"
                                    class="form-control-file"
                                    id="screeningVideoRecord"  multiple  accept="video/*" capture @change="onScreeningVideoSelected"
                                    @click="startsmAnsweringAQuestion()"
                                    hidden
                                />
                            </span>
                            <span class="btn button-create backgroundcolorblack borderradius20 white mt-4 ansrbtn ml-3 d-block d-lg-none" :disabled="doneAnswerbtnClicked" v-if="doneAnswerbtnClicked && !submitButtonClicked" @click="AddIntoFinalList">
                                <span class="bold16px_white proximanova">Next</span>
                            </span>
                            <img src="../assets/uploadvideo.svg" alt="uploading" width="30px" class="img-fluid ml-5 mt-4 d-block d-lg-none" v-if="submitButtonClicked">
                        </div>
                    </div>
                    <div class="ml-3 mr-3 ml-lg-5 mr-lg-5 d-flex flex-column  my-auto" v-if="questionsEnded">
                        <div class="text-center my-auto d-flex flex-column">
                            <img src="../assets/PaymentSucessfull.svg" alt="successful" width="80" class="mx-auto mt-4">
                            <span class="fontsize32 proximanova black">Congratulations</span>
                            <span class="fontsize16 proximanova black">Successfully answered all the {{screeningQuestions.length}} questions in {{totalSecondsTookToAnswer | minutesAndSeconds}} and submitted</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal> 
  </div>
</template>
<script>
import router from '../router.js'
import httpuserprofile from "@/js/http-userprofile.js";
import APIerrorModal from '../components/APIerrorpopup.vue'
import sessionUtils from '@/js/session-util.js'
export default {
    components: {
        APIerrorModal
    },
    data() {
        return {
            pageloader : true,
            currentUserProfileId : null,
            jobId : null,
            instructions : [
                'Once you start answering your screen recording will start recording.',
                'Each question will have 30sec to answer.',
                'You can only answer one after the other.',
                'Once you confirm the answer then only the question will allow you to answer.',
                'Once you confirmed can’t edit the answer.'
            ],
            screeningQuestions : [
                // {questionId : 15 , question : 'What is an Array ?'},
                // {questionId : 16 , question : 'What is Multi-threading ?'},
                // {questionId : 17 , question : 'What are the life cycle hooks in vuejs ?'},
            ],
            //recorder instance
            screeningqsnrecordingVideo : null,
            screeningqsnrecorder  : null,
            beforeStartAnswering : true,
            submitButtonClicked : false,
            //for lg devices
            startedAnswering : false,
            doneAnswerbtnClicked : false,
            previewPlaying : false,
            // for sm/md devices
            startedsmAnswering : false,
            // donesmAnswerbtnClicked : false,
            videoUploadingErrorMessage : null,
            totalSeconds : 60,
            totalSecondsTookToAnswer : 0,
            recordedVideo : null,
            // final result
            isVideoMuted : false,
            questionsEnded : false,
            selectedQsnIndex : 0,
            selectedQsnId : null,
            selectedQsn : null,
            displayAPIerrorModal : false,
        };
    },
    filters: {
    minutesAndSeconds (value) {
      var minutes = Math.floor(parseInt(value, 10) / 60)
      var seconds = parseInt(value, 10) - minutes * 60
      if(seconds > 9){
          return `${minutes}:${seconds}`
      }else{
          return `${minutes}:0${seconds}`
      }
      
    }
  },
    methods : {
        closeAPIerrorModal(){
            this.displayAPIerrorModal = false;
        },
        NavToJobsPage : function(){
            this.$router.go(-1);
        },
        ///this will invoke after click on start Answering button to start the video recordings for screening questions
        startAnsweringQuestions(){
            this.beforeStartAnswering = false;
            this.doneAnswerbtnClicked = false;
            this.selectQuestionToAnswer()
        },
        // this will invoke initially when click on start answering / done answering
        selectQuestionToAnswer(){
            this.startedAnswering = false;
            this.startedsmAnswering = false;
            this.doneAnswerbtnClicked = false;
            this.recordedVideo = null;
            if(this.selectedQsnIndex < this.screeningQuestions.length) {
                this.selectedQsn = this.screeningQuestions[this.selectedQsnIndex].question;
                this.selectedQsnId = this.screeningQuestions[this.selectedQsnIndex].questionId;
                this.selectedQsnIndex++
            }else{
                this.questionsEnded = true;
                //make a call to apply to the job
                this.ApplyJob()
            }
            
        },
        ApplyJob() {
            var vm = this;
            let obj = {
                jobId: this.jobId,
                userProfileId: this.currentUserProfileId,
                jobStatus: "POST",
                creationD: null,
                creationUserI: sessionUtils.getUserEmail(),
                updateD: null,
                updatedUserI:null  
            }
            console.log(obj)
            httpuserprofile.post('/userprofile/ApplyToJob', obj)
            .then(response => {    
                console.log("apply for a job : ", response)
                if(response.data.errorCode !== 1047 && response.data.errorCode !== 1007) {
                    vm.$toast.success("Applied successfully")
                }
                this.stopCamera()
            }).catch(error=>{   
                console.log(error);  
                this.displayAPIerrorModal = true;
            }) 
            // this has  to be called once get successfully applied for the job
            // this.MoveToRecordScreeningQuestions()
        },
        // this will invoke after click on mute / unmute button on the video
        muteUnmuteVideo(){
            let video = document.getElementById('videscreeningqsns')
            if(this.isVideoMuted){
                video.volume = 1
            }else{
                video.volume = 0
            }
            this.isVideoMuted = !this.isVideoMuted
        },
        previewPlay(){
            let video = document.getElementById('videscreeningqsns')
            if(this.previewPlaying) {
                video.pause();
                this.previewPlaying = false;
            }else{
                video.play()
                this.previewPlaying = true;
            }
        },
        endPlayingVideo() {
            this.previewPlaying = false;
        },
        AddIntoFinalList(){
            if(this.doneAnswerbtnClicked) {
                this.submitButtonClicked = true;
                var that = this;
                var screeningfd = new FormData()
                let obj = {
                    jobId : this.jobId,
                    questionId : this.selectedQsnId,
                    userProfileId : this.currentUserProfileId
                }
                var pblob = new Blob([JSON.stringify(obj)], { type: "application/json" })
                screeningfd.append("videoData", pblob)
                screeningfd.append("screeningVideo", this.recordedVideo)
                httpuserprofile.post('/userprofile/JobScreeningQuestionAnsers', screeningfd, {
                    headers: {
                    "Content-Type": "multipart/form-data",
                    "Accept" : "*/*"
                    }
                }).then((response) => {
                    console.log(response)
                    this.submitButtonClicked = false;
                    var video = document.getElementById('videscreeningqsns');
                    var source = document.getElementById('sourcepost')
                    video.removeAttribute('src')
                    source.removeAttribute('src')
                    video.load()
                    //reset data and get camera access
                    this.totalSeconds = 60;
                    this.selectQuestionToAnswer()
                    var w = window.innerWidth;
                    if(w > 780){
                        that.getCameraAccess();
                    }
                }).catch((e) => {
                    this.submitButtonClicked = false;
                    console.log(e)
                    this.displayAPIerrorModal = true;
                })
            }else{
                this.submitButtonClicked = false;
                console.log("you have to complete the ansr first")
            }
        },
        /// this will invoke initially component mounted 
        /// getting the webcam access
        getCameraAccess(){
            var that = this;
            this.screeningqsnrecordingVideo = document.getElementById('videscreeningqsns')
            captureCamera(function(camera) {
                that.screeningqsnrecordingVideo.muted = true;
                that.screeningqsnrecordingVideo.volume = 0;
                that.screeningqsnrecordingVideo.srcObject = camera;
                that.screeningqsnrecorder = RecordRTC(camera, {
                    type: 'video',
                    mimeType: 'video/webm',
                    canvas: {
                        width: 1280,
                        height: 720
                    }, 
                    timeSlice: 1000
                });
                // that.runTimer();
                //stop recording when rach to 120 sec
                var recordingDuration = 60000;
                that.screeningqsnrecorder.setRecordingDuration(recordingDuration).onRecordingStopped(stopRecordingCallback);
            
                // that.screeningqsnrecorder.startRecording();
                // that.screeningqsnrecorder.pauseRecording()
                that.screeningqsnrecorder.camera = camera;
            });
            function captureCamera(callback) {
                navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(function(camera) {
                    callback(camera);
                }).catch(function(error) {
                console.error(error);
                that.$toast.info('Unable to capture your camera. Please use other way to upload video'); 
                });
            }
            function stopRecordingCallback() {
                that.doneAnswerbtnClicked = true;
                that.screeningqsnrecordingVideo.src = that.screeningqsnrecordingVideo.srcObject = null;
                that.screeningqsnrecordingVideo.muted = false;
                that.screeningqsnrecordingVideo.volume = 1;
                that.screeningqsnrecordingVideo.src = URL.createObjectURL(that.screeningqsnrecorder.getBlob());
                that.recordedVideo = that.screeningqsnrecorder.getBlob()
                clearInterval(that.timer)
                that.screeningqsnrecorder = null;
            }
        },
        //this will invoke after clickign on start answering button in small and medium devices
        startsmAnsweringAQuestion(){
            this.doneAnswerbtnClicked = false;
            document.getElementById('screeningVideoRecord').click()
        },
        //this will invoke after click on start answering/re-record button to get the video from mobile/tab devices
        //validations for video
        onScreeningVideoSelected(event){
            console.log("check : ", event.target.files)
            let that = this;
            this.recordedVideo = event.target.files[0]
            var file = event.target.files[0];
            var fsize = file.size
            var fduration;
            var fwidth;
            var fheight;
            var ffile = Math.round((fsize / 1024 / 1024));
            var prevideo = document.createElement('video');
            prevideo.preload = 'metadata';
            prevideo.onloadedmetadata = function() {
                window.URL.revokeObjectURL(prevideo.src);
                fduration = prevideo.duration;
                checkDuration()
            }
            prevideo.src = webkitURL.createObjectURL(event.target.files[0]);;
            function checkDuration(){
                if(fduration>0 && fduration < 60){
                    that.videoUploadingErrorMessage = null;
                    proccedToValidation()
                }else{
                    that.videoUploadingErrorMessage = "Video must be between 0 to 60 seconds long."
                    return
                }
            }
            console.log("file type : ", file.type)
            function proccedToValidation(){
                if(ffile <= 400){
                if(file.type == 'video/mp4' || file.type == 'video/quicktime' || file.type == 'video/mov' || file.type == 'video/webm') {
                    var reader = new FileReader();
                    reader.onload = function(e){
                    var src = that.recordedVideo;
                    var blob = new Blob([src], {type: 'video/mp4'});
                    var url = webkitURL.createObjectURL(blob);
                    console.log("url : ", url)
                    var video = document.getElementById('videscreeningqsns');
                    var source = document.getElementById('sourcepost')
                    video.removeAttribute('src')
                    source.removeAttribute('src')
                    video.setAttribute('src', url)
                    source.setAttribute('src', url)
                    var timer = setInterval(function () {
                        if (video.readyState === 4){
                            fduration = Math.round(video.duration)
                            fwidth = video.videoWidth
                            fheight = video.videoHeight
                            console.log("video duration : ", fduration)
                            console.log("video width : ", fwidth)
                            console.log("video height : ", fheight)
                            clearInterval(timer);
                        }
                        }, 500)
                        video.load();
                        video.pause()
                        video.addEventListener('error', function(err){
                        // This craps out in Safari 6
                        console.error(video.error, err);
                        alert("browser doesn't support preview");
                        });
                        console.log("video : ", video)
                    }
                    reader.readAsDataURL(file)
                    that.totalSecondsTookToAnswer = that.totalSecondsTookToAnswer + fduration;
                    that.startedsmAnswering = true;
                    that.doneAnswerbtnClicked = true;
                }else{
                    console.log("please upload valid format video")
                    that.videoUploadingErrorMessage = "Video format is not valid"
                }
                }else{
                console.log("file size is less than 400mb")
                that.videoUploadingErrorMessage = "File size must be less than 400mb"
                }
            }
        },
        /// this will invoke after click on start Answering button to start the video recordings for screening questions
        startAnsweringAQuestion(){
            this.startedAnswering = true;
            this.doneAnswerbtnClicked = false;
            this.screeningqsnrecorder.startRecording()
            this.runTimer();
        },
        /// this will invoke aftre click on done answering button to stop recording
        doneAnsweringAQuestion(){
            var that = this;
            this.doneAnswerbtnClicked = true;
            that.screeningqsnrecorder.stopRecording(stopRecordingCallback);
            function stopRecordingCallback() {
                that.screeningqsnrecordingVideo.src = that.screeningqsnrecordingVideo.srcObject = null;
                that.screeningqsnrecordingVideo.muted = false;
                that.screeningqsnrecordingVideo.volume = 1;
                that.screeningqsnrecordingVideo.src = URL.createObjectURL(that.screeningqsnrecorder.getBlob());
                that.recordedVideo = that.screeningqsnrecorder.getBlob()
                clearInterval(that.timer)
                // that.screeningqsnrecorder = null;
                // that.AddIntoFinalList()
            }
        },
        /// this will invoke after click on start recording to get the timer countdown
        runTimer(){
        var that = this;
        this.timer = setInterval(tick, 1000);
            function tick(){
                if(that.totalSeconds !== 0){
                that.totalSeconds--
                that.totalSecondsTookToAnswer++
                }
            }
        },
        /// this will invoke after move out of the page / click on back button to stop the webcam access
        stopCamera(){
            var that = this
            if(that.screeningqsnrecorder !== null){
                that.screeningqsnrecorder.camera.stop();
                that.screeningqsnrecorder = null;
            }
        },
        //this will invoke after component created 
        //get webcam access 
        getScreeningQuestionsList(){
            var that = this
            httpuserprofile.get('/userprofile/getScreeningQuestionByJobId?jobId='+this.jobId)
            .then((response) => {
                this.pageloader = false;
                console.log(response)
                if(response.data){
                    this.screeningQuestions = response.data;
                }
                setTimeout(function() {
                    var w = window.innerWidth;
                    if(w > 780){
                        that.getCameraAccess();
                    }
                },2000);
            }).catch((e) => {
                console.log(e.response)
                this.pageloader = false;
            })
        }
    },
    mounted(){
        this.currentUserProfileId = sessionUtils.getUserProfileId();
        this.jobId = this.$session.get("selectedJobId")
        this.getScreeningQuestionsList()
    },
    beforeDestroy(){
        this.stopCamera()
    }
};
</script>
<style scoped>
.card{
    border-radius: 10px;
}
#bottom {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
.volumebtn{
    width: 35px;
    height: 35px;
    background: white;
    border-radius: 50%;
    padding: 5px;
}
.black_overlay2 {
  /* background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 100%); */
  background: rgba(0, 0, 0, .5);
  border-radius: 0 4px 5px 4px;
  padding: 5px;
}
#videscreeningqsns{
    width: 100% !important;
    border-radius: 10px;
    border: 5px solid black;
    background: black;
}
.ansrbtn{
    width: 200px;
}
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}
.countdownstyles{
    width: 60px;
    padding: 10px 12px;
    background: black;
    color: white;
    border-radius: 16px;
}
@media screen and (max-width: 767px) {
  .vidheight {
      height: 250px !important;
  }
  .pageloader {
    width: 20%;
    margin-top: 25%;
  }
}
@media screen and (max-width: 1100px) and (min-width: 768px) {
  .vidheight {
      height: 300px !important;
  }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
@media screen and (min-width: 1100px) {
  .vidheight {
      height: 350px !important;
  }
}
</style>